// @tennis-matches/clubmeisterschaft-core – Platzhalter bis Finish-Page existiert

import React from "react";
import { useOutletContext } from "react-router-dom";

export function ClubmeisterschaftFinishPlaceholder() {
  const { t } = useOutletContext() || {};
  const label = t ? t("club.finish.title") : "club.finish.title";
  return (
    <div className="card" data-page="clubmeisterschaft-finish-placeholder">
      <p className="muted">{label}</p>
    </div>
  );
}
